<ion-app>
  <app-splash-screen *ngIf="isAppLoading" [stopLoading]="apisDone" (animationComplete)="onSplashAnimationComplete()">
  </app-splash-screen>

  <app-loader *ngIf="!isAppLoading"></app-loader>
  <ion-router-outlet></ion-router-outlet>
  <app-version-update *ngIf="isVersionMismatch" [header]="versionService.versionData?.header"
    [description]="versionService.versionData?.description" [version]="versionService.versionData?.version_number"
    (close)="isVersionMismatch = false">
  </app-version-update>

</ion-app>